export const deleteWpDefaultClasses = () => {
  const wpBlockList = document.querySelectorAll(
    ".js-delete-class-wp-block-list"
  );

  wpBlockList.forEach((elm) => {
    elm.classList.remove("wp-block-list");
  });
};
